import Logo from "./../../assets/images/logo-splash.png";
import PhoneFrame from "../../components/layout/PhoneFrame";
import "./hasRegistered.css";

export default function HasRegistered() {
  const bazar = () => {
    window.location.href =
      "https://cafebazaar.ir/app/ir.scab.app?ref=developer_badge";
  };
  const download = () => {
    window.location.href = "https://scab.ir/download";
  };
  const test = () => {
    window.location.href = "./";
  };
  return (
    <PhoneFrame className="bg-scabWhite">
      <div className="w-full min-h-full relative flex justify-center content-start flex-wrap">
        <div className="w-full h-full absolute left-0 top-0 img-bg -z-50"></div>
        <div className="w-[220px] mt-[80px]">
          <img className="w-full" src={Logo} alt="" />
        </div>
        <div className="w-[320px] text-scabBlack text-large flex justify-center text-justify items-center font-[600] mt-[40px] ">
          کاربر گرامی شما قبلا در سامانه ثبت نام کرده‌اید، جهت تکمیل اطلاعات
          کاربری و یا اجرای سرویس، اپلیکیشن راننده را نصب کنید.
        </div>
        <div className="w-full flex justify-center mt-[70px] flex-wrap">
          <button
            className={`px-4 py-2 rounded-lg mx-[10px] font-IRANSansBold border bg-[#10b981]`}
            onClick={bazar}
          >
            دریافت از بازار
          </button>
          <button
            className={`px-4 py-2 rounded-lg mx-[10px] font-IRANSansBold border bg-[#ffcf30]`}
            onClick={download}
          >
            دانلود مستقیم
          </button>
          <button
            className={`px-4 py-2 rounded-lg mx-[10px] font-IRANSansBold border bg-[#FC9700]`}
            onClick={test}
          >
            بعدا
          </button>
        </div>
      </div>
    </PhoneFrame>
  );
}
